import {
    EDITOR_IMAGE_TYPE,
    EDITOR_IMAGE_MAX_SIZE,
} from 'common/constants/files';
import { FileUpload } from 'common/components/ContentEditor/elements/file/FileUpload';
import { options } from 'common/components/ContentEditor/options';
import { useContentEditor } from 'common/components/ContentEditor/hooks/useContentEditor';
import {
    IToolbarButtonProps,
    ToolbarButton,
} from 'common/components/ContentEditor/components/EditorToolbar/ToolbarButton';

import { addOrReplaceImage } from './utils';

interface IProps extends IToolbarButtonProps {
    img?: typeof options.img;
}

export const ToolbarImage = ({
    img = options.img,
    tooltip,
    ...other
}: IProps) => {
    const editor = useContentEditor();

    const handleSuccess = (url: string) => {
        addOrReplaceImage(editor, url);
    };

    return (
        <FileUpload
            id="toolbar-image-upload"
            inputProps={{ accept: EDITOR_IMAGE_TYPE }}
            maxSize={EDITOR_IMAGE_MAX_SIZE}
            onSuccess={handleSuccess}
        >
            <ToolbarButton
                active={editor.api.some({ match: { type: img.type } })}
                tooltip={tooltip}
                {...other}
            />
        </FileUpload>
    );
};
